import { format, parseISO, isValid } from 'date-fns';
import { DISPLAY_DATE, DISPLAY_DATE_TIME_SECONDS } from './constants';

const currencyFormatter = new Intl.NumberFormat('en-GB', {
	style: 'currency',
	currency: 'GBP',
});

export type DynamicFieldValue = undefined | null | string | number | boolean;

const dateTimeFieldChecks = ['badgeDate', 'dateOfBirth', 'nextDirectDebitDue', 'dateOfPayment', 'dueDate'];

export const formatDynamicFieldValue = (value: DynamicFieldValue, fieldName?: string, truncate = false) => {
	if (value === undefined || value === null) return '';

	if (typeof value === 'string') {
		const possibleDate = parseISO(value);
		if (isValid(possibleDate)) {
			const dontShowTime = dateTimeFieldChecks.includes(fieldName as string);
			return format(new Date(value), dontShowTime ? DISPLAY_DATE : DISPLAY_DATE_TIME_SECONDS);
		}

		return truncate ? `${value.substring(0, 50)}....` : value;
	}

	if (typeof value === 'boolean') return value ? 'Yes' : 'No';
	return value;
};

export const formatCurrency = (amount: number) => currencyFormatter.format(amount);

export const formatCamelCaseToRegular = (camelCase: string) => {
	const temp = camelCase.replace(/([A-Z])/g, ' $1').replace(/^./, (str) => str.toUpperCase());
	return temp.replace(/(\d)/g, ' $1');
};

export const getDatesInfo = (
	now: Date,
	future: Date,
): {
	days: string[];
	months: string[];
	years: string[];
	hours: string[];
	minutes: string[];
	seconds: string[];
} => {
	future.setDate(future.getDate() + 30);

	const days = [now.getDate().toString(), future.getDate().toString()];
	const months = [
		now.toLocaleString('default', { month: 'long' }),
		future.toLocaleString('default', { month: 'long' }),
	];
	const years = [now.getFullYear().toString(), future.getFullYear().toString()];
	const hours = [now.getHours().toString(), future.getHours().toString()];
	const minutes = [now.getMinutes().toString(), future.getMinutes().toString()];
	const seconds = [now.getSeconds().toString(), future.getSeconds().toString()];

	return { days, months, years, hours, minutes, seconds };
};
